export default {
    TYPE: {
        FIXED: 'FIXED',
        PERCENT: 'PERCENT',
    },
};
